<script setup>
import { ref, computed } from 'vue';
import BlockChat from './BlockChat.vue';
import store from '@/store';
import { isLitePackage } from '@/helper/packageTier';

const isOpen = ref(false);

const isLitePackageValue = computed(() => isLitePackage(store.state.profile));
</script>
<template>
	<div v-if="!isOpen && !isLitePackageValue" class="cursor-pointer" @click="isOpen = !isOpen">
		<div class="relative">
			<img
				class="block h-12 w-auto"
				src="@/assets/images/icons/ask-luca-ai.png"
				alt=""
			/>
			<img
				src="@/assets/images/icons/close.png"
				alt="close"
				class="absolute top-0 right-0 w-4 h-4"
				@click.stop="$emit('close')"
			/>
		</div>
	</div>
	<div v-if="isOpen && !isLitePackageValue" class="bubble-chat-popup fixed z-50 bg-white shadow-md">
		<BlockChat @close="isOpen = false" />
	</div>
</template>

<style scoped>
.border-b-neutral-200 {
	border-bottom: 1px solid #e1e7ef;
}
.border-b-neutral-200:last-child {
	border-bottom: none;
}
.border-r-neutral-200 {
	border-right: 1px solid #e1e7ef;
}
.active-student:hover {
	background-color: #faf5f1;
}
.border-input {
	border: 1px solid #f1f5f9;
}
.chat-box {
	min-height: 0;
}

.bubble-chat-popup {
	right: 76px;
	bottom: 0;
	width: calc(100vw - 92px);
	max-width: 700px;
	height: 560px;
	overflow: hidden;
	border-top-left-radius: 0.5rem;
	border-top-right-radius: 0.5rem;
}

@media screen and (max-width: 767px) {
	.bubble-chat-popup {
		right: 0;
		left: 0;
		bottom: 0;
		width: 100vw;
		max-width: none;
		height: 100vh;
		height: 100dvh;
		border-radius: 0;
	}
}
</style>
